import { Controller } from "@hotwired/stimulus"
import { Calendar } from "@fullcalendar/core"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import interactionPlugin from "@fullcalendar/interaction"

export default class extends Controller {
  connect() {
    this.calendar = new Calendar(this.element, {
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      initialView: 'timeGridWeek',
      locale: 'pt-br',
      fixedWeekCount: false,
      height: "auto",
      slotMinTime: "08:00:00",
      slotMaxTime: "22:00:00",
      scrollTime: "08:00:00",
      nowIndicator: true,
      editable: false,
      selectable: false,
      events: this.loadEvents.bind(this),
      eventDidMount: this.decorateEvent.bind(this),
      datesSet: this.updateBookingCount.bind(this)
    })

    this.calendar.render()
  }

  async loadEvents(fetchInfo, successCallback, failureCallback) {
    try {
      const response = await fetch(`/admin/calendar.json?start_date=${fetchInfo.startStr}&end_date=${fetchInfo.endStr}`)
      const data = await response.json()
      successCallback(data)

      this.currentEvents = data
      this.updateBookingCount(fetchInfo)
    } catch (error) {
      failureCallback(error)
    }
  }

  updateBookingCount(fetchInfo) {
    const count = this.currentEvents?.length || 0
    const badge = document.getElementById("weekly-booking-count")
    if (badge) badge.textContent = `${count} agendamentos para este período`
  }

  decorateEvent(info) {
    const status = info.event.extendedProps.status
    info.el.classList.add(`status-${status}`)

    const tooltipContent = `
      <strong>Paciente:</strong> ${info.event.extendedProps.patientName || 'N/A'}<br>
      <strong>Psi:</strong> ${info.event.extendedProps.psiName || 'N/A'}<br>
      <strong>Horário:</strong> ${info.event.start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}<br>
      <strong>Status:</strong> ${info.event.extendedProps.statusText}
    `

    info.el.setAttribute("title", tooltipContent)
    info.el.setAttribute("data-bs-toggle", "tooltip")
    info.el.setAttribute("data-bs-html", "true")

    const existingTooltip = bootstrap.Tooltip.getInstance(info.el)
    if (existingTooltip) {
      existingTooltip.dispose()
    }

    new bootstrap.Tooltip(info.el)
  }
}
